import React from "react"
import Layout from "../components/Layout"
import { SEO } from "../components/SEO/SEO"
import { PageHero } from "../components/programmatic/PageHero"
import { ContentSections } from "../components/programmatic/ContentSections"
import { FAQBlock } from "../components/programmatic/FAQBlock"
import { ServiceCTA } from "../components/programmatic/ServiceCTA"
import { RelatedLinks } from "../components/programmatic/RelatedLinks"
import { Breadcrumbs } from "../components/programmatic/Breadcrumbs"
import { AuthorBox } from "../components/programmatic/AuthorBox"
import { buildLocalBusiness } from "../components/SEO/schema/localBusiness"
import { buildService } from "../components/SEO/schema/service"
import { buildFaqPage } from "../components/SEO/schema/faqPage"
import { buildBreadcrumbList } from "../components/SEO/schema/breadcrumbList"
import type { ServiceHub } from "../data/types"

type Props = {
  pageContext: ServiceHub
}

const ServiceHubTemplate = ({ pageContext }: Props) => {
  const path = `/${pageContext.slug}`
  const crumbs = [
    { name: "Início", to: "/" },
    { name: pageContext.title, to: path },
  ]

  const jsonLd = [
    buildLocalBusiness(),
    buildService({
      name: pageContext.title,
      description: pageContext.metaDescription,
      url: path,
      serviceType: pageContext.title,
    }),
    buildFaqPage(pageContext.faq),
    buildBreadcrumbList(crumbs),
  ]

  return (
    <Layout>
      <SEO
        title={pageContext.metaTitle}
        description={pageContext.metaDescription}
        canonicalPath={path}
        jsonLd={jsonLd}
      />
      <Breadcrumbs crumbs={crumbs} />
      <PageHero
        eyebrow="Atendimento"
        headline={pageContext.hero.headline}
        intro={pageContext.hero.intro}
      />
      <ContentSections sections={pageContext.sections} />
      <ServiceCTA
        prefill={pageContext.ctaPrefill}
        headline={`Quer experimentar uma sessão de ${pageContext.title}?`}
        buttonLabel="Agendar pelo WhatsApp"
      />
      <FAQBlock faq={pageContext.faq} />
      <RelatedLinks links={pageContext.related} />
      <AuthorBox />
    </Layout>
  )
}

export default ServiceHubTemplate
